import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
Vue.use(Router);

// create new router

const routes = [

  {
    path: "/",
    component: () => import("./views/about_us"),
    children: [
      {
        path: "",
        name: 'homepage',
        component: () => import("./views/about_us/homePage.vue"),
      },
      {
        path: "homepage",
        name: 'homepage',
        redirect: '/',
        component: () => import("./views/about_us/homePage.vue"),
      },

      {
        path: "why_us",
        name: 'why_us',
        component: () => import("./views/about_us/why_us.vue"),
      },
      {
        path: "legal",
        name: 'legal',
        component: () => import("./views/about_us/legal.vue"),
      },
      {
        path: "faq",
        name: 'faq',
        component: () => import("./views/about_us/faq.vue"),
      },
      {
        path: "ourLicensing",
        name: 'ourLicensing',
        component: () => import("./views/about_us/ourLicensing.vue"),
      },
      {
        path: "contact_us",
        name: 'ourLicensing',
        component: () => import("./views/about_us/contact_us.vue"),
      },

    ]
  },
  {
    path: "/trading",
    component: () => import("./views/trading"),
    children: [
      {
        path: "account_type",
        name: 'account_type',
        component: () => import("./views/trading/account_type.vue"),
      },
      {
        path: "deposit_n_withdrawal",
        name: 'deposit_n_withdrawal',
        component: () => import("./views/trading/deposit_n_withdrawal.vue"),
      },
      {
        path: "mt5TradingPlatform",
        name: 'mt5TradingPlatform',
        component: () => import("./views/trading/mt5TradingPlatform.vue"),
      },
      {
        path: "fixApi",
        name: 'fixApi',
        component: () => import("./views/trading/fixApi.vue"),
      },

    ]
  },
  {
    path: "/portfolio",
    component: () => import("./views/portfolio"),
    children: [
      {
        path: "pamm",
        name: 'pamm',
        component: () => import("./views/portfolio/pamm.vue"),
      },
      {
        path: "portfolio_management",
        name: 'portfolio_management',
        component: () => import("./views/portfolio/portfolio_management.vue"),
      },
    ]
  },
  {
    path: "/partnerships",
    name: 'partnership',
    component: () => import("./views/partnerships/partner.vue"),
  },
  {
    path: "*",
    component: () => import("./views/pages/notFound")
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "open",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
// var liveChat = document.getElementById('chat-widget-container');
router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.


  if (from.path.includes('manage')) {
    next();

  } else {
    if (to.path) {
      // Start the route progress bar.

      NProgress.start();
      NProgress.set(0.1);
    }
    next();

  }
});

router.afterEach(() => {
  // Remove initial loading
  var content = document.getElementById('top');
  if (content) {
    content.scrollTo({ top: 0, behavior: "smooth" });
  }
  const gullPreLoading = document.getElementById("loading_wrap");
  if (gullPreLoading) {
    gullPreLoading.style.display = "none";
  }
  setTimeout(() => NProgress.done(), 100);
});

export default router;
